module.exports = __webpack_public_path__ + "static/media/Tawuniya-Logo.b70789ab.svg";